// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"04452113","372":"0bc418ef","583":"0b083df9","895":"6ac59f0a"}[chunkId] + ".chunk.js";
};